import React, { useEffect } from 'react';
import StandardLanding from '../../../shared/components/StandardLanding';
import TableInformationOperation from '../components/TableInformationOperation';
import { useDispatch, useSelector } from 'react-redux';
import { deleteInfoOperation } from '../action';
import { getReportType, getInfoOperationList } from '../../general/action';
import { getUnitList } from '../../user-accounts/action';
import { message } from 'antd';

const Landing = () => {
  const dispatch = useDispatch();
  const state = useSelector((state) => state);
  const role = state.profile.showProfile?.role;
  const { reportType, listInfo, loading } = state.general;

  const { listUnit } = state.account;

  useEffect(() => {
    console.log('check');
    const name = 'information_operations';
    dispatch(getReportType(name));
    dispatch(getInfoOperationList());
    dispatch(getUnitList());
  }, []);

  return (
    <StandardLanding>
      <div className='main-container content-crop'>
        <div className='flex justify-between'>
          <p className='lg-title text-blue-10'>INFORMATION OPERATIONS</p>
          <p className='md-title text-gray-20'>
            View tabulated summary of reports here
          </p>
        </div>
        <div className='mt-2'>
          {state && (
            <TableInformationOperation
              loading={loading}
              listInfo={listInfo}
              listUnit={listUnit}
              reportType={reportType}
              deleteInfoOperation={deleteInfoOperation}
              getInfoOperationList={getInfoOperationList}
              role={role}
            />
          )}
        </div>
      </div>
    </StandardLanding>
  );
};

export default Landing;
